import {ListPatientTherapySequencesFilters} from '@cypro/engine/queries'
import {PreparationType, VolumeMode} from '@cypro/engine/database/schema'
import {CarrierSolutionValidationSchema} from '@cypro/engine/utils'
import * as z from 'zod'

export const PatientsTherapiesFiltersSchema = ListPatientTherapySequencesFilters
export type PatientsTherapiesFiltersSchema = z.infer<typeof PatientsTherapiesFiltersSchema>
export const MedicineDetail = z
  .object({id: z.string(), prescribedNameId: z.string().optional()})
  .superRefine((value, ctx) => {
    if (!value.prescribedNameId) {
      ctx.addIssue({
        code: 'custom',
        path: ['prescribedNameId'],
        message: 'A prescribed name is required',
      })
    }
  })
export type MedicineDetail = z.infer<typeof MedicineDetail>

export const Consumable = z.object({id: z.string(), quantity: z.number()})
export type Consumable = z.infer<typeof Consumable>
export const ParameterSchema = z
  .object({
    carrierSolutionId: z.string().optional(),
    applicationFormId: z.string(),
    duration: z.number(),
    volume: z.number().min(1).optional(),
    volumeMode: VolumeMode.optional(),
    preparationType: PreparationType.optional(),
    medicine: z.array(MedicineDetail),
    consumables: z.array(Consumable),
  })
  .superRefine((value, ctx) => {
    const carrierValidation = CarrierSolutionValidationSchema.safeParse({
      carrierSolutionId: value.carrierSolutionId,
      volume: value.volume,
      volumeMode: value.volumeMode,
    })
    if (carrierValidation.success) return

    for (const issue of carrierValidation.error.issues) {
      ctx.addIssue({
        code: 'custom',
        path: issue.path,
        message: issue.message,
      })
    }
  })

export type ParameterSchema = z.infer<typeof ParameterSchema>

export function getDefaultParameterFormValues(): ParameterSchema {
  return {
    carrierSolutionId: undefined,
    applicationFormId: '',
    duration: 0,
    volume: undefined,
    volumeMode: undefined,
    preparationType: undefined,
    medicine: [],
    consumables: [],
  }
}
